import styled from 'styled-components';

export const GeneralSettingsStyled = styled.div`
  .customize-code {
    overflow: auto;
    max-width: 42rem;
    position: relative;
    max-height: 10rem;
  }
  .copy-code {
    position: absolute;
    top: 1.5rem;
    right: 1rem;
  }
  pre {
    padding: 8px;
    background-color: rgb(246, 246, 247);
    border-radius: 1rem;
    width: 100%;
    white-space: break-spaces;
  }
  code {
    background-color: rgba(235, 236, 239, 1);
    border-radius: 0.5rem;
    padding: 2px;
  }
  .w-100 {
    width: 100%;
  }
`;
